import { takeLatest, put, call } from "redux-saga/effects";
import {
  GET_NODES_SERVICE_REQUEST,
  GET_NODES_SERVICE_SUCCESS,
  GET_NODES_SERVICE_FAILURE,
  GET_NODE_BY_ID_SERVICE_REQUEST,
  GET_NODE_BY_ID_SERVICE_SUCCESS,
  GET_NODE_BY_ID_SERVICE_FAILURE,
  UPDATE_NODE_STATUS_SERVICE_REQUEST,
  UPDATE_NODE_STATUS_SERVICE_SUCCESS,
  UPDATE_NODE_STATUS_SERVICE_FAILURE,
  DELETE_NODE_SERVICE_REQUEST,
  DELETE_NODE_SERVICE_SUCCESS,
  DELETE_NODE_SERVICE_FAILURE,
  CHECK_NODE_HEALTH_SERVICE_REQUEST,
  CHECK_NODE_HEALTH_SERVICE_SUCCESS,
  CHECK_NODE_HEALTH_SERVICE_FAILURE,
} from "./actions";
import {
  getNodes,
  getNodeById,
  updateNodeStatus,
  deleteNode,
  checkNodeHealth,
} from "../../api/node";

// Node listesi
function* getNodesSaga() {
  try {
    const response = yield call(getNodes);
    console.log("Saga Response:", response);
    if (response && response.data && response.data.body && response.data.body.result) {
      yield put({
        type: GET_NODES_SERVICE_SUCCESS,
        payload: response.data.body.result,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: GET_NODES_SERVICE_FAILURE,
      payload: error.message || "Veri alınamadı",
    });
  }
}

// Tek bir node getirme
function* getNodeByIdSaga(action) {
  try {
    const response = yield call(getNodeById, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: GET_NODE_BY_ID_SERVICE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: GET_NODE_BY_ID_SERVICE_FAILURE,
      payload: error.message || "Veri alınamadı",
    });
  }
}

// Node durumu güncelleme
function* updateNodeStatusSaga(action) {
  try {
    const response = yield call(updateNodeStatus, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: UPDATE_NODE_STATUS_SERVICE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: UPDATE_NODE_STATUS_SERVICE_FAILURE,
      payload: error.message || "Güncelleme başarısız",
    });
  }
}

// Node silme
function* deleteNodeSaga(action) {
  try {
    const response = yield call(deleteNode, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      yield put({
        type: DELETE_NODE_SERVICE_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: DELETE_NODE_SERVICE_FAILURE,
      payload: error.message || "Silme işlemi başarısız",
    });
  }
}

function* checkNodeHealthSaga(action) {
  try {
    const response = yield call(checkNodeHealth, action.payload);
    console.log("Saga Response:", response);
    if (response && response.data) {
      // API yanıtını dizi olarak işle
      const nodeHealthData = Array.isArray(response.data.data) ? response.data.data : [];
      
      yield put({
        type: CHECK_NODE_HEALTH_SERVICE_SUCCESS,
        payload: nodeHealthData,
      });
    } else {
      throw new Error("API yanıtı geçersiz");
    }
  } catch (error) {
    console.error("Saga Error:", error);
    yield put({
      type: CHECK_NODE_HEALTH_SERVICE_FAILURE,
      payload: error.message || "Sağlık kontrolü başarısız",
    });
  }
}

export default function* nodeSaga() {
  yield takeLatest(GET_NODES_SERVICE_REQUEST, getNodesSaga);
  yield takeLatest(GET_NODE_BY_ID_SERVICE_REQUEST, getNodeByIdSaga);
  yield takeLatest(UPDATE_NODE_STATUS_SERVICE_REQUEST, updateNodeStatusSaga);
  yield takeLatest(DELETE_NODE_SERVICE_REQUEST, deleteNodeSaga);
  yield takeLatest(CHECK_NODE_HEALTH_SERVICE_REQUEST, checkNodeHealthSaga);
} 